"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import _ from "underscore";
import "../../api/account";
import classNames from "classnames";
import DocumentThumbnailList from "../document_thumbnail_list";
import "../popout";
import LoadIdAndStatus from "./load_id_and_status";
import { History } from "react-router";
import Auth from "../../util/auth";
import AddDocumentToLoad from "./add_document_to_load";
function selectGroup(props, group) {
  props.onPageSelected(group.documents[0].pages[0]);
}
function pageSelected(props, pages) {
  props.onPageSelected(pages[0]);
}
function showCombinedGroups(props) {
  const documents = _.flatten(_.map(props.groups, (group) => group.documents));
  return /* @__PURE__ */ jsx(
    DocumentThumbnailList,
    {
      documents,
      collapseSingleGroup: props.collapseSingleGroup,
      onContextMenu: onContextMenu(props, props.groups[0]),
      setSelectedPages: (pages) => pageSelected(props, pages),
      selectedPages: selectedPages(props),
      selectedLoad: props.selectedLoad,
      loadState: props.loadState,
      documentLoadRelationships: props.documentLoadRelationships
    }
  );
}
function showThumbnailList(props, group) {
  return /* @__PURE__ */ jsx(
    DocumentThumbnailList,
    {
      documents: group.documents,
      relatedDocuments: group.relatedDocuments,
      relatedDocumentsTitle: group.relatedDocumentsTitle,
      relatedDocumentsLoading: group.relatedDocumentsLoading,
      collapseSingleGroup: props.collapseSingleGroup,
      onContextMenu: onContextMenu(props, group),
      setSelectedPages: (pages) => pageSelected(props, pages),
      selectedPages: selectedPages(props),
      selectedLoad: props.selectedLoad,
      loadState: props.loadState,
      documentLoadRelationships: props.documentLoadRelationships
    }
  );
}
function selectedPages(props) {
  return [props.selectedPage];
}
function onContextMenu(props, group) {
  if (props.onContextMenu) {
    return _.partial(props.onContextMenu, group);
  }
}
function isGroupedByDocBatch(props, group) {
  const isGroupable = group.url || group.name == "Uploaded Documents";
  return isGroupable && props.isConfirmAndSubmit;
}
function groupHeading(props, group) {
  if (isGroupedByDocBatch(props, group) && group.url) {
    const isIndexAuditSplitEnabled = !!Auth._currentUser.account.settings.index_audit_split_enabled;
    if (isIndexAuditSplitEnabled) {
      return "Re-index ";
    } else {
      return "View Email";
    }
  } else {
    return group.name;
  }
}
function showCollapsedGroup(props, group) {
  const hash = {};
  hash["document-browser__collapsed-list"] = true;
  hash["document-browser__ignored"] = group.ignored;
  const classes = classNames(hash);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "document-browser__list-item document-browser__list-item--collapsed",
      title: "Go to next group - Alt+G\nGo to previous group - Alt+Shift+G",
      children: [
        /* @__PURE__ */ jsxs("div", { className: classes, onClick: () => selectGroup(props, group), children: [
          /* @__PURE__ */ jsxs("h6", { children: [
            group.name,
            /* @__PURE__ */ jsx("a", { className: "document-browser__collapsed-list-link" })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "document-browser__collapsed-list-documents", children: [
            group.documents.length,
            " documents"
          ] })
        ] }),
        /* @__PURE__ */ jsx(LoadIdAndStatus, { group })
      ]
    },
    group.number
  );
}
const DocumentGroupList = React.createClass({
  mixins: [History],
  componentDidMount: function() {
    const list = ReactDOM.findDOMNode(this.refs.list);
    this.baseHeight = list.offsetHeight;
    const first_child = [...list.children].find(
      (node) => node.className !== "document-browser__add-document-wrapper"
    );
    this.topOffset = $(first_child.children[0]).offset().top + 120;
  },
  componentDidUpdate: function() {
    const list = ReactDOM.findDOMNode(this.refs.list);
    const offset = $(".document-thumbnail__page--selected").offset();
    if (offset) {
      const currentScroll = list.scrollTop;
      list.scrollTop = currentScroll + offset.top - this.topOffset;
    }
  },
  render: function() {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        "data-component": "DocumentGroupList",
        ref: "list",
        className: "document-browser__document-list",
        children: [
          /* @__PURE__ */ jsx(
            AddDocumentToLoad,
            {
              isConfirmAndSubmit: this.props.isConfirmAndSubmit,
              loadState: this.props.loadState,
              carrierInvoice: this.props.carrierInvoice
            }
          ),
          this.showThumbnailListOrGroups()
        ]
      }
    );
  },
  showThumbnailListOrGroups: function() {
    if (this.props.groups.length === 1 && this.props.collapseSingleGroup) {
      return showThumbnailList(this.props, this.props.groups[0]);
    }
    const groupedByDoctype = !!Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled && this.props.groups.every(
      (group) => isGroupedByDocBatch(this.props, group)
    );
    if (groupedByDoctype) {
      return showCombinedGroups(this.props);
    }
    return /* @__PURE__ */ jsx("div", { children: _.map(this.props.groups, this.showGroup) });
  },
  showSelectedGroup: function(group) {
    const showGroupHeading = !Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled || !isGroupedByDocBatch(this.props, group);
    let classes = "document-browser__list-item";
    if (group.groupType) {
      classes += " document-browser__list-item--" + group.groupType;
    }
    return /* @__PURE__ */ jsxs("div", { className: classes, children: [
      showGroupHeading && /* @__PURE__ */ jsx(
        "h6",
        {
          onClick: () => this.groupClicked(group),
          className: "document-browser__group-heading",
          children: groupHeading(this.props, group)
        }
      ),
      showThumbnailList(this.props, group)
    ] }, group.number);
  },
  groupClicked: function(group) {
    if (group.url && !group.areLoadDocuments) {
      const invoiceId = group.documents[0].carrier_invoice_id || group.documents[0].factor_invoice_id;
      const onDone = this.props.location.query.onDone || "/dashboard";
      this.history.pushState(null, group.url, { invoiceId, onDone });
    } else if (group.url && group.areLoadDocuments) {
      const onDone = this.props.location.query.onDone || "/dashboard";
      this.history.pushState(null, group.url, { onDone });
    }
  },
  showGroup: function(group) {
    if (group.selected) {
      return this.showSelectedGroup(group);
    }
    return showCollapsedGroup(this.props, group);
  }
});
export default DocumentGroupList;
